export default "__VITE_ASSET__013e7376__"